export enum ShareType {
  TWITTER = "Twitter",
  COPY_TEXT = "Copy text",
  LINK_TEXT = "Link + Text",
  COPY_LINK = "Copy link",
  COPY_LINK_MOBILE = "Copy link mobile",
}
